import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@/core/store/store'

const currentUser = (state: RootState) => state.accountReducer
export const currentUserSelector = createSelector(
  currentUser,
  accountReducer => accountReducer.currentUser,
)

const isAuth = (state: RootState) => state.accountReducer
export const authSelector = createSelector(
  isAuth,
  accountReducer => accountReducer.isAuth,
)

const role = (state: RootState) => state.accountReducer
export const roleSelector = createSelector(
  role,
  accountReducer => accountReducer.role,
)

export const userRoleSelector = createSelector(
  role,
  accountReducer => accountReducer.userRole,
)

export const connectedReselleridSelector = createSelector(
  role,
  accountReducer => accountReducer.connectedResellerId,
)
